/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Calendar = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 21" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M19.178 21H2.822C1.266 21 0 19.745 0 18.204V3.802C0 2.26 1.266 1.006 2.822 1.006h2.184V0h1.987v1.006h8.014V0h1.987v1.006h2.184C20.734 1.006 22 2.26 22 3.802v14.402C22 19.745 20.734 21 19.178 21zM6.993 3.006v1.002H5.006V3.006h-.02v-.019H2.822A.819.819 0 0 0 2 3.802v3.19h18v-3.19a.819.819 0 0 0-.822-.815h-2.184v1.02h-1.987V3.006zM2 18.204c0 .45.369.814.822.814h16.356a.818.818 0 0 0 .822-.814V8.992H2z" />
      </g>
    </svg>
  </span>
);

Calendar.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Calendar.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Calendar;
